import {
  Building2,
  CircleUser,
  Circle,
  House,
  ListChecks,
  Mail,
  ScrollText,
  Settings,
  Shield,
  Smartphone,
  UserCog,
  Users,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/** Icon names come from module manifests (lucide names). Unknown names fall back to a plain circle. */
const ICONS: Record<string, LucideIcon> = {
  house: House,
  users: Users,
  shield: Shield,
  settings: Settings,
  mail: Mail,
  'scroll-text': ScrollText,
  'building-2': Building2,
  'user-cog': UserCog,
  'list-checks': ListChecks,
  'circle-user': CircleUser,
  smartphone: Smartphone,
};

export function NavIcon({ name, className = 'h-5 w-5 shrink-0' }: { name: string; className?: string }) {
  const Icon = ICONS[name] ?? Circle;
  return <Icon aria-hidden="true" className={className} />;
}
